<div id="wrap">
    <header class="header" *ngIf="!isPopup">
        <div class="header_inner">
            <h1 class="header_logo">
                <a href="" class="logo"><img src="/assets/images/web/logo/logo_348.png" alt="OASIS BUDDY" /></a>
            </h1>
            <span class="util_right" *ngIf="!user" >
                <a (click)="moveJoin()" class="btn_join"><b>회원가입</b></a>
                <a href="https://www.oasis.co.kr" target="_blank" class="btn_oasis ico_blank">오아시스마켓</a>
            </span>
            <span class="util_right" *ngIf="user">
                <button type="button" (click)="openGuideWindow()" class="btn_box">이용가이드</button>
                <a routerLink="/mypage/main" class="btn_mypage" *ngIf="!user.isAdmin"><b>MY page</b></a>
                <a class="btn_logout" (click)="logout()"><b>LOGOUT</b></a>
            </span>
        </div>
    </header>

    <div id="content">
        <div id="skip_anchor" class="content page_guide">
            <div class="form_guide">
                <strong class="guide_title">이용가이드</strong>
                <p class="guide_subscript">컨텐츠 창작자들이 오아시스마켓 식품을 홍보하고 수익을 창출할 수 있는 <b>최고의 비즈니스 플랫폼</b> 입니다.</p>
                <div class="guide_tab">
                    <ng-container *ngFor="let item of contentCategoryList">
                        <button type="button" (click)="selectCategory(item.contentCategoryNo)" [ngClass]="item.contentCategoryNo == contentCategoryNo ? 'active': ''" [attr.contentCategoryNo]="item.contentCategoryNo" class="tab_item">{{item.contentCategoryName}}</button>
                    </ng-container>
                </div>
                <ul class="guide_list">
                    <ng-container *ngIf="guideList && guideList.length > 0">
                        <li class="guide_item" *ngFor="let item of guideList">
                            <button type="button" [ngClass]="item.selected ? 'open': ''" (click)="selectContent(item)" class="guide_label">{{item.title}}</button>
                            <div class="guide_text">
                                <pre>{{item.webDescription}}</pre>
                            </div>
                        </li>
                    </ng-container>
                    <ng-container *ngIf="!(guideList && guideList.length > 0)">
                        <li class="guide_item guide_no">등록된 가이드가 존재하지 않습니다.</li>
                    </ng-container>
                </ul>
            </div>
        </div>
    </div>

    <footer class="footer" *ngIf="!isPopup">
        <app-footer></app-footer>
    </footer>
</div>
